import React, { useRef, useEffect, useState } from 'react';

const HeroSection = () => {
  const videoRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Ensure video plays on mount
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log("Video autoplay prevented:", error);
      });
    }
  }, []);

  return (
    <section
      id="home"
      className="h-screen w-full bg-black flex items-center justify-center relative overflow-hidden"
    >
      {/* Loading placeholder - shows while video loads */}
      {!isLoaded && (
        <div className="absolute inset-0 bg-black flex items-center justify-center">
          <div className="text-[#A47F2D] text-sm tracking-widest animate-pulse">
            LOADING...
          </div>
        </div>
      )}

      {/* Fullscreen Video Animation */}
      <div className="absolute inset-0 w-full h-full">
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          onLoadedData={() => setIsLoaded(true)}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
            isLoaded ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <source src="/animations/landing.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        
        {/* Optional: Dark overlay for better text visibility if needed */}
        <div className="absolute inset-0 bg-black/20"></div>
      </div>

      {/* Optional: Content overlay - remove if you don't need any text */}
      {/* <div className="relative z-10 text-center text-white">
        <h1 className="text-5xl font-bold">Welcome</h1>
      </div> */}
    </section>
  );
};

export default HeroSection;